import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { AppSubNav } from "@components/widgets/AppSubNav/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { DuplicateRequestForInvoicing } from "@src/components/modules/invoices/Create/modules/DuplicateRequestForInvoicing";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Duplicate Request for invoicing`}
    navigation={<AppSubNav defaultBackButtonUrl="/invoices/for-invoicing" />}
  >
    <DuplicateRequestForInvoicing id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/invoices/for-invoicing/duplicate")({
  component: RouteComponent,
});
